/**
 * Persist opened cloud runs on this device so RideView can open them offline
 * (metadata here; telemetry in runTelemetrySnapshots).
 */

import localforage from 'localforage';
import { normalizeForStorage, denormalizeFromStorage } from './pageCache';
import { saveRunTelemetrySnapshot } from './runTelemetrySnapshot';

const detailStore = localforage.createInstance({
  name: 'shokiq-pwa',
  storeName: 'offlineRunDetailV1',
});

function storeKey(userId, runId) {
  return `${userId}::${runId}`;
}

/**
 * Save run fields for offline open. Telemetry is stored via runTelemetrySnapshots when present.
 * @param {string} userId
 * @param {string} runId
 * @param {object} runData — same shape as RideView `rideData` after cloud load (may include telemetryData)
 */
export async function saveOfflineRunDetailCache(userId, runId, runData) {
  if (!userId || !runId || !runData || typeof runData !== 'object') return;
  const { telemetryData, ...meta } = runData;
  const normalized = normalizeForStorage(meta);
  await detailStore.setItem(storeKey(userId, runId), normalized);
  if (Array.isArray(telemetryData) && telemetryData.length > 0) {
    await saveRunTelemetrySnapshot(userId, runId, telemetryData);
  }
}

/** @returns {Promise<object|null>} denormalized metadata (no guaranteed `id`; caller adds rideId) */
export async function loadOfflineRunDetailCache(userId, runId) {
  if (!userId || !runId) return null;
  try {
    const raw = await detailStore.getItem(storeKey(userId, runId));
    if (!raw || typeof raw !== 'object') return null;
    return denormalizeFromStorage(raw);
  } catch {
    return null;
  }
}

export async function removeOfflineRunDetailCache(userId, runId) {
  if (!userId || !runId) return;
  try {
    await detailStore.removeItem(storeKey(userId, runId));
  } catch {
    // ignore
  }
}
